export default {
  zh: {
    panelName: '报告',
    reportName: '报告名称',
    sectionNames: {
      name: '1. 输入报告名称',
      criteria: '2. 设置筛选条件',
      format: '3. 设置报告类型',
      display: '4. 设置显示字段',
    },
    formats: {
      summary: '汇总',
      matrix: 'Matrix',
    },
    errors: {
      name: '报告名称不能为空！',
      type: '报告类型不能为空！',
      group: '至少需要选中一列作为分组列！',
      aggregate: '至少需要选中一列作为聚合列！',
      groupMax: '分组列的总列数需不超过1列!',
      totalMax: '报告总列数需不超过10列!',
    }
  },
  en: {
    panelName: 'Report',
    reportName: 'Report Name',
    sectionNames: {
      name: '1. Enter Report Name',
      criteria: '2. Specify Filter Criteria',
      format: '3. Select Report Format',
      display: '4. Select Fields To Display',
    },
    formats: {
      summary: 'Summary',
      matrix: 'Matrix',
    },
    errors: {
      name: 'Report name is required!',
      type: 'Report type is required!',
      group: 'Group zone is required!',
      aggregate: 'Aggregates zone is required!',
      groupMax: 'Total Columns of Group Zones should not larger than 1!',
      totalMax: 'Total Columns of the report should not larger than 10!'
    }
  },
};



// WEBPACK FOOTER //
// ./src/views/ReportFilters/i18n.js